import React from 'react';
import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';

export const ExperienceOrderCard = () => {
    return (
        <div className='card-detail-experience rounded-lg'>

            <div style={{ color: '#67BAAF', fontSize: '16px' }}>
                Masaje Terracota:
            </div>

            <p className='mt-2' style={{ color: '#4B5563' }}>
                Dos artesanos terapeutas te renovarán totalmente con este masaje a 4 manos. Esta exclusiva terapia artesanal estimula al cuerpo y la mente de manera simétrica y armónica.
            </p>

            <div className='flex justify-between items-center mt-4 mb-10'>
                <span style={{ fontSize: '14px' }}>Fecha de reservación:</span>
                <div className="inline-block relative" style={{ width: '166px' }}>
                    <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                        style={{ height: '50px' }}>
                        <option>1 - Dic - 2021</option>
                        <option>2 - Dic - 2021</option>
                        <option>3 - Dic - 2021</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#67BAAF' >11:00 a.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >12:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >01:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >02:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >05:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >06:00 p.m.</GeneralButtonComponent>
                </div>
            </div>

            <div className='flex justify-between mt-10 items-center'>
                <div className='text-right'>
                    <span>Por persona</span>
                    <br />
                    <span className='total_price_lg'>USD $100</span>
                </div>
                <div>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-6' bgcolor='#67BAAF'  >Reservar</GeneralButtonComponent>
                </div>
            </div>
        </div>
    );
};
